



























import {Component, Prop, Vue} from "vue-property-decorator";
import axios from "axios";
import {AxiosUtils} from "@/axios-utils";

@Component
export default class UserInfoChangePassword extends Vue {
    @Prop() private isVisible!: boolean;

    /** パスワード変更メールを送信する */
    sendChangePasswordMail() {
        // パスワード変更メール送信をリクエストする
        axios.put("/password/send-change-password-mail")
            .then(() => {
                // 成功した場合はダイアログを閉じる
                this.$emit('close', true);
            })
            .catch(error => {
                AxiosUtils.gotoClientErrorPage(error, this.$router)
            });
    }

    /** 画面の非表示 */
    close() {
        // ダイアログを閉じる
        this.$emit('close', null);
    }
}
